export default __webpack_public_path__ + "static/media/Respiratory Rate.55c6ea0c.svg";